import axios from "../../axios";

const updateWithdraw = async function (accessToken,id,params = {}) {
    try {
        const response = await axios.post('admin/withdraw/updateWithdraw', params,{
            headers: {
                'Authorization': accessToken
            },
            params: {
                id
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default updateWithdraw;
